import { LeaveEntitlementsPanel } from '../../components/LeaveEntitlementsPanel';

// This route already requires settings.manage (see App.tsx), so the panel
// is always shown in its manage-capable form here.
export function LeaveEntitlementPolicies() {
  return (
    <>
      <header className="page-header">
        <h1>Leave Entitlement Policies</h1>
      </header>

      <LeaveEntitlementsPanel canManage />
    </>
  );
}
